export default {
    data() {
        return {
            slider: null,
            isPressing: false,
            startX: null,
            scrollLeft: null,
        };
    },
    mounted() {
        this.slider = this.$refs.slider;

        this.slider.addEventListener("mousedown", this.startDrag);
        this.slider.addEventListener("touchstart", this.startDrag);

        this.slider.addEventListener("mousemove", this.move);
        this.slider.addEventListener("touchmove", this.move);

        this.slider.addEventListener("mouseleave", this.endDrag);
        this.slider.addEventListener("mouseup", this.endDrag);
        this.slider.addEventListener("touchend", this.endDrag);
    },
    beforeUnmount() {
        this.slider.removeEventListener("mousedown", this.startDrag);
        this.slider.removeEventListener("touchstart", this.startDrag);

        this.slider.removeEventListener("mousemove", this.move);
        this.slider.removeEventListener("touchmove", this.move);

        this.slider.removeEventListener("mouseleave", this.endDrag);
        this.slider.removeEventListener("mouseup", this.endDrag);
        this.slider.removeEventListener("touchend", this.endDrag);
    },
    methods: {
        startDrag(event) {
            this.isPressing = true;
            this.startX =
                event.pageX || event.touches[0].pageX - this.slider.offsetLeft;
            this.scrollLeft = this.slider.scrollLeft;
        },
        endDrag() {
            this.isPressing = false;
        },
        move(event) {
            if (!this.isPressing) {
                return;
            }

            const x =
                event.pageX || event.touches[0].pageX - this.slider.offsetLeft;
            const dist = x - this.startX;
            this.slider.scrollLeft = this.scrollLeft - dist;
        },
    },
};
